<mat-sidenav-container class="layout">
  <mat-sidenav #drawer class="sidenav" [mode]="sidenavMode">
    <div class="sidenav-content">
      <div class="logo-container">
        <img
          src="../assets/Alas - Logotipo Final WEB JPEG (1).jpg"
          alt="Logo"
          class="logo"
        />
      </div>

      <nav class="menu">
        <div class="inner-text">
          <a
            mat-button
            routerLink="/inicio"
            (click)="drawer.close()"
            class="action"
          >
            <mat-icon>home</mat-icon>
            <span>Inicio</span>
          </a>
        </div>
        <div class="inner-text" *ngIf="auth.rol === 'admin'">
          <a
            mat-button
            routerLink="/rutas"
            (click)="drawer.close()"
            class="action"
          >
            <mat-icon>add_road</mat-icon>
            <span>Rutas</span>
          </a>
        </div>
        <div class="inner-text">
          <a
            mat-button
            routerLink="/solicitudes"
            (click)="drawer.close()"
            class="action"
          >
            <mat-icon>assignment</mat-icon>
            <span>Solicitudes</span>
          </a>
        </div>
        <div class="inner-text">
          <a
            mat-button
            routerLink="/viajes"
            (click)="drawer.close()"
            class="action"
          >
            <mat-icon>directions_car</mat-icon>
            <span>Viajes</span>
          </a>
        </div>
        <div class="inner-text">
          <a
            mat-button
            routerLink="/parametros"
            (click)="drawer.close()"
            class="action"
          >
            <mat-icon>tune</mat-icon>
            <span>Parámetros</span>
          </a>
        </div>
      </nav>

      <app-footer class="footer"></app-footer>
    </div>
  </mat-sidenav>

  <mat-sidenav-content class="main">
    <mat-toolbar class="header" *ngIf="auth.isAuthenticated()">
      <button
        mat-icon-button
        (click)="drawer.toggle()"
        class="menu-button"
        aria-label="Menú"
      >
        <mat-icon>menu</mat-icon>
      </button>

      <div class="container-basic-info">
        <button mat-icon-button class="btn-info" [matMenuTriggerFor]="userMenu">
          <mat-icon style="font-size: 20px">person</mat-icon>
        </button>

        <mat-menu #userMenu="matMenu">
          <button mat-menu-item (click)="logout()">
            <mat-icon>logout</mat-icon>
            <span>Cerrar sesión</span>
          </button>
        </mat-menu>
      </div>
    </mat-toolbar>

    <main class="page-content">
      <router-outlet></router-outlet>
    </main>
  </mat-sidenav-content>
</mat-sidenav-container>
